// Some app URLs carry a bearer credential: the Teacher Check token, the gift
// code, the one-time confirmation token (?v=) and the phone-upload token.
// Datadog RUM records page URLs (view.url / view.referrer) and, when enabled,
// resource and error URLs, so these would land in RUM for anyone with Datadog
// access. scrubRumEvent rewrites those exact shapes to placeholders before an
// event is sent; every other URL is left exactly as it is.

const TOKEN = '[0-9A-Za-z]{16,64}(?![0-9A-Za-z])';

const RULES = [
  // /#/check/<token> and /check/<token> (never /check/verify: too short).
  [new RegExp(`(/check/)${TOKEN}`, 'g'), '$1[token]'],
  // /#/thanks/<code>
  [new RegExp(`(/thanks/)${TOKEN}`, 'g'), '$1[code]'],
  // /#/check/verify?v=<43> and /#/gift/verify?v=<43>
  [new RegExp(`([?&]v=)${TOKEN}`, 'g'), '$1[token]'],
  // API paths: /api/teacher-check/<token>, /teacher-checks/<token>/…
  [new RegExp(`(/teacher-checks?/)${TOKEN}`, 'g'), '$1[token]'],
  // /api/gifts/<code>, /gifts/<code>/claim
  [new RegExp(`(/gifts/)${TOKEN}`, 'g'), '$1[code]'],
  // /#/m/upload/<token> (the phone-upload screen also skips RUM entirely)
  [/(\/m\/upload\/)[^/?#&\s]+/g, '$1[token]'],
];

export const scrubUrl = (value) => {
  if (typeof value !== 'string' || !value) return value;
  return RULES.reduce(
    (url, [pattern, replacement]) => url.replace(pattern, replacement),
    value
  );
};

/** Datadog RUM beforeSend: scrubs in place and never drops an event. */
export const scrubRumEvent = (event) => {
  try {
    if (event?.view) {
      if (typeof event.view.url === 'string')
        event.view.url = scrubUrl(event.view.url);
      if (typeof event.view.referrer === 'string')
        event.view.referrer = scrubUrl(event.view.referrer);
    }
    if (event?.resource && typeof event.resource.url === 'string') {
      event.resource.url = scrubUrl(event.resource.url);
    }
    if (
      event?.error?.resource &&
      typeof event.error.resource.url === 'string'
    ) {
      event.error.resource.url = scrubUrl(event.error.resource.url);
    }
  } catch {
    // Scrubbing must never break monitoring.
  }
  return true;
};
